
$('.atd-shop-the-product-carousel').owlCarousel({
    loop: true,
    nav: true,
    dots: false,
    items:1,
    margin: 20,
    slideTransition: 'linear',
    touchDrag: true,
    autoplay: false,
    autoplayTimeout: 4500,
    smartSpeed: 600,
    center:true,
})